import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDmUJVZoc46G9TkTvQhJayPhTJnrMXhnqw",
  authDomain: "schoolwebsite-8eff5.firebaseapp.com",
  projectId: "schoolwebsite-8eff5",
  storageBucket: "schoolwebsite-8eff5.firebasestorage.app",
  messagingSenderId: "1075860348837",
  appId: "1:1075860348837:web:6db40f0541b775eaf9524c",
  measurementId: "G-VWF73TGNS9"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);